<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="margin_large_bottom single-help"
    id="htlp-page"
  >
    <PageHeader />
    <ModuleBuilder
      v-if="currentPage.acf && currentPage.acf.modules"
      class="modules"
      :modules="currentPage.acf.modules"
    />
    <RelatedHelps
      v-if="currentPage && currentPage.acf"
      title="Kanskje du er interessert i dette også?"
      :categories="currentPage.acf._categories"
    />
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
import RelatedHelps from "@/components/modules/RelatedHelps";

export default {
  name: "single-help",
  components: {
    RelatedHelps
  },
  data() {
    return {};
  },
  computed: {}
};
</script>

<style lang="scss">
@import "./../assets/scss/mixins.scss";
@import "./../assets/scss/vars.scss";
.single-help {
}
</style>
